import { putChangeActiveBrands } from '../api/putChangeActiveBrands';
import { setGetBrandsById } from './setGetBrandsById';

export const setPutChangeActiveBrands = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putChangeActiveBrands(params);
            
            alert('Сохранено')
          
            dispatch(setGetBrandsById(params))
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}